import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { formatNumber2 } from "utils/currencyFormat"

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch}) => {

    const handlePageChange = (pageNumber) => {
        const newSearchData = { ...dataSearch, pageIndex: pageNumber };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
    };

    const handlePageSizeChange = (pageSize) => {
        const newSearchData = { ...dataSearch, pageSize, pageIndex: 1 };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
    };

    return (
        <>
            {isLoading ? (
                <div className="loading-page1"><div className="loader loader-default is-active"></div></div>
            ) : (
                <>
                    <div className="card border-light mb-2 card-v2">
                        <div className="card-body card-body-v2">
                            <div className="Left808x200 Table-main-new css-table-ds">
                                <div className="table-mobile table-mobile-hover">
                                    <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                        <div className="table-headers" style={{alignItems: 'stretch'}}>
                                            <div className="custom-table-header text-center flex-basis-5 flex-basis-5-sm">
                                                <p className="color-do-bold">STT <br />[{listDanhSach.TotalRow}]</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-12 flex-basis-12-sm">
                                                <p>Mã giao dịch</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                                <p>Loại</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-18 flex-basis-18-sm">
                                                <p>Nhân viên</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                                <p>Khách hàng</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-10 flex-basis-10-sm">
                                                <p>Ngày tạo</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-10 flex-basis-10-sm">
                                                <p>Ngày thu/chi</p>
                                            </div>
                                            <div className="custom-table-header text-right flex-basis-15 flex-basis-15-sm">
                                                <p className="color-do-bold">Số tiền <br />[{formatNumber2(listDanhSach.TotalValue)}]</p>
                                            </div>
                                        </div>

                                        <div className="custom-table-body">
                                            <ContentTable 
                                                listDanhSach={listDanhSach.Transactions}
                                                phanQuyen={phanQuyen}
                                                dataSearch={dataSearch}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {listDanhSach.TotalRow > 0 && (
                        <div className="card border-light mb-2 card-v2">
                            <div className="card-body card-body-v2">
                                <PhanTrang
                                    pageIndex={dataSearch.pageIndex}
                                    pageSize={dataSearch.pageSize}
                                    totalCount={listDanhSach.TotalRow}
                                    onPageChange={handlePageChange}
                                    onPageSizeChange={handlePageSizeChange}
                                />
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};